// 配置API接口地址
// var root = '//fcovapi.52dd.cn/'; // 测试环境
var root = '//api.52dd.cn/'; // 正式环境
//   var root='http://192.168.10.137/'
// var root='https://yice.dd668.cn/'//易测

// let root = 'http://local.api.52dd.cn/';
// 引用axios
var axios = require('axios');

// 接口配置文件
import { UrlConfig } from './config';
// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}
/*
  接口处理函数
  这个函数每个项目都是不一样的，我现在调整的是适用于
  https://cnodejs.org/api/v1 的接口，如果是其他接口
  需要根据接口的参数进行调整。参考说明文档地址：
  https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
  主要是，不同的接口的成功标识和失败提示是不一致的。
  另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers['Content-Type'] = 'multipart/form-data';
// axios.defaults.headers['Content-Type'] = 'application/json';
// axios.defaults.headers['Content-Type'] = 'text/plain';
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

function apiAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params);
  }

  if (UrlConfig.fromidUrl[url]) {
    var fromid = UrlConfig.getUrlQuery('fromid');
    if (fromid) {
      params.fromid = UrlConfig.getUrlQuery('fromid');
    }
  }

  axios({
    method: method,
    // 处理成 php form data     t
    transformRequest: [
      function (data) {
        let ret = '';
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
        return ret;
      },
    ],
    // 处理成 php form data     b
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: root,
    withCredentials: false,
  })
    .then(function (res) {
      success(res.data);
      // if (res.data.success == 0) {
      //   if (success) {
      //     success(res.data)
      //   }
      // } else {
      //   if (failure) {
      //     failure(res.data)
      //   } else {
      //     window.alert('error: ' + JSON.stringify(res.data))
      //   }
      // }
    })
    .catch(function (err) {
      // 这里的代码会在 then 函数里的代码执行错误或异常时调用（请务必注意这里，特别是调用apiAxios外层的回调函数）
      let res = err.response;
      // console.log(err)
      // console.log(res)
      if (err) {
        // window.alert('api error, HTTP CODE: ' + res.status)
      }
    });
}

// 返回在vue模板中的调用接口
export default {
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure);
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure);
  },
  put: function (url, params, success, failure) {
    return apiAxios('PUT', url, params, success, failure);
  },
  delete: function (url, params, success, failure) {
    return apiAxios('DELETE', url, params, success, failure);
  },
  Post: function (url, params, success, failure) {
    // $Glb.PlMessage: 消息层 ( 显示内容,显示时间,回调函数 )
    // $Vue.$Glb.PlMessage("正在加载中...", 10000, () => {
    //   $Vue.$Glb.PlMessage('请求超时，请重试', 800)
    // });
    return apiAxios(
      'POST',
      url,
      params,
      function (res) {
        // $Glb.PlMessageNone: 隐藏 消息层
        // $Vue.$Glb.PlMessageNone()
        success(res);
      },
      failure
    );
  },
};



// WEBPACK FOOTER //
// ./src/api/index.js